import React, { useCallback } from 'react';
import classNames from 'classnames';
import CheckToggleField from 'components/CheckToggleField';
import { useTranslation } from 'react-i18next';
import { Field, useForm, useFormState } from 'react-final-form';
import RichTextEditorField from 'components/RichTextEditorField';
import validations from 'validations';
import { CreateDataRoomShareableLinkForm } from 'models/ShareableLink';
import { INCLUDE_NDA_NAME } from '../ShareableLinkNda/ShareableLinkNda.component';

import './ShareableLinkTermsAndConditions.styles.scss';

export const INCLUDE_T_AND_C_NAME = 'includeTermsAndConditionProtection';

type ShareableLinkTermsAndConditionsProps = {
  className?: string;
  showPrefilledNote?: boolean;
};

const ShareableLinkTermsAndConditions: React.FC<
  ShareableLinkTermsAndConditionsProps
> = (props) => {
  const { className, showPrefilledNote = false } = props;

  const classes = classNames(
    'shareable-links-terms-and-conditions',
    'column',
    className,
  );

  const {
    values: { includeTermsAndConditionProtection },
  } = useFormState<CreateDataRoomShareableLinkForm>();
  const { change } = useForm();

  const { t } = useTranslation();

  const handleOnToogle = useCallback(
    (checked: boolean) => {
      if (checked) {
        change(INCLUDE_NDA_NAME, false);
      }
    },
    [change],
  );

  return (
    <div className={classes}>
      <Field
        name={INCLUDE_T_AND_C_NAME}
        type="checkbox"
        className="green-check-toggle"
        component={CheckToggleField}
        label={<span>{t('tAndC')}</span>}
        customOnChange={handleOnToogle}
      />

      {includeTermsAndConditionProtection && (
        <>
          {showPrefilledNote && (
            <p className="tc-prefilled-value">{t('tAndCprefilled')}</p>
          )}

          <RichTextEditorField
            name="termsAndConditionsContent"
            required
            canExpand
            expandedModalLabel={t('tAndC')}
            validate={validations.richEditorRequired()}
          />
        </>
      )}
    </div>
  );
};

export default ShareableLinkTermsAndConditions;
